// Desktop-only memory of who last signed in on this computer and which branch they were in.
const KEY = 'dutilyne_desktop_last_signin';

export const isDesktopApp = () => typeof window !== 'undefined' && !!window.pharmxai;

export const getLastSignin = () => {
  if (!isDesktopApp()) return null;
  try { return JSON.parse(localStorage.getItem(KEY)) || null; } catch { return null; }
};

export const saveLastSignin = (patch) => {
  if (!isDesktopApp()) return;
  localStorage.setItem(KEY, JSON.stringify({ ...(getLastSignin() || {}), ...patch }));
};

export const forgetLastSignin = () => localStorage.removeItem(KEY);
